/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Search_Action_StartInputs */

const en_us2_search_action_start = /** @type {(inputs: Search_Action_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start Workout ${i?.label}`)
};

const pt_br2_search_action_start = /** @type {(inputs: Search_Action_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Começar Treino ${i?.label}`)
};

const es_419_search_action_start = /** @type {(inputs: Search_Action_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empezar Entrenamiento ${i?.label}`)
};

const pt_pt2_search_action_start = /** @type {(inputs: Search_Action_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Começar Treino ${i?.label}`)
};

const fr_fr2_search_action_start = /** @type {(inputs: Search_Action_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commencer la séance ${i?.label}`)
};

const de_de2_search_action_start = /** @type {(inputs: Search_Action_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Training ${i?.label} starten`)
};

const it_it2_search_action_start = /** @type {(inputs: Search_Action_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia Allenamento ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Start Workout {label}" |
*
* @param {Search_Action_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_start = /** @type {((inputs: Search_Action_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_start(inputs)
	if (locale === "es-419") return es_419_search_action_start(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_start(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_start(inputs)
	if (locale === "de-DE") return de_de2_search_action_start(inputs)
	if (locale === "it-IT") return it_it2_search_action_start(inputs)
	return en_us2_search_action_start(inputs)
});
export { search_action_start as "search.action_start" }